<template>
  <component
    :is="type"
    :schema="schema"
    :on-action-callback="onActionCallback"
    v-model="val"
    v-bind="extraProps()"
  />
</template>

<script>
import SchemaFormElementText from '@/components/SchemaFormElementText'
import SchemaFormElementNumber from '@/components/SchemaFormElementNumber'
import SchemaFormElementSelect from '@/components/SchemaFormElementSelect'
import SchemaFormElementDatepicker from '@/components/SchemaFormElementDatepicker'
import SchemaFormElementTaginput from '@/components/SchemaFormElementTaginput'
import SchemaFormElementConst from '@/components/SchemaFormElementConst'

import SchemaFormElementMixin from '@/mixins/SchemaFormElementMixin'

export default {
  name: 'SchemaFormElement',
  mixins: [SchemaFormElementMixin],
  props: {
    onActionCallback: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      onInputCallbacks: []
    }
  },
  computed: {
    type() {
      let component = SchemaFormElementText

      if (this.schema.enum !== undefined && this.schema.examples !== undefined) {
        component = SchemaFormElementSelect
      }
      if (this.schema.enum !== undefined) {
        component = SchemaFormElementSelect
      } else if (this.schema.type === 'number') {
        component = SchemaFormElementNumber
      } else if (
        this.schema.type === 'string' &&
        ['date', 'date-time'].includes(this.schema.format || '')
      ) {
        component = SchemaFormElementDatepicker
      } else if (this.schema.type === 'array' && typeof this.schema.examples !== 'undefined') {
        component = SchemaFormElementTaginput
      } else if (typeof this.schema.const !== 'undefined') {
        component = SchemaFormElementConst
      }

      return component
    }
  },
  methods: {
    extraProps() {
      if (this.schema.enum !== undefined && this.schema.examples !== undefined) {
        let result = []
        for (let i = 0; i < this.schema.enum.length; i++) {
          result.push({
            title: this.schema.enum[i],
            description: this.schema.examples[i]
          })
        }

        return {
          selectOptions: result
        }
      } else {
        return {}
      }
    }
  },
  watch: {
    val(newValue) {
      if (newValue) {
        this.onInputCallbacks.forEach(cb => cb(newValue))
      }
    }
  },
  created() {
    if (!Array.isArray(this.schema.$actions)) return

    for (const action of this.schema.$actions) {
      const { on, value, contains, notContains, notValue } = action.trigger

      if (on === 'input') {
        this.onInputCallbacks.push(input => {
          return this.onActionCallback(action, input)
        })
      } else if (on === 'load') {
        // this.isPerformingAction = true
        // const rv = this.onActionCallback(action, this.value)
        // this.stopPerformingActions([rv])
        this.onActionCallback(action, this.value)
      } else if (typeof contains !== 'undefined') {
        this.onInputCallbacks.push(input => {
          if (input.includes(contains)) return this.onActionCallback(action, input)
        })
      } else if (typeof notContains !== 'undefined') {
        this.onInputCallbacks.push(input => {
          if (!input.includes(notContains)) return this.onActionCallback(action, input)
        })
      } else if (typeof value !== 'undefined') {
        this.onInputCallbacks.push(input => {
          // TODO: there must be a better way to check for equality
          if (value === input) return this.onActionCallback(action, input)
        })
      } else if (typeof notValue !== 'undefined') {
        this.onInputCallbacks.push(input => {
          // TODO: there must be a better way to check for equality
          if (notValue !== input) return this.onActionCallback(action, input)
        })
      }
    }
  }
}
</script>
